import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Registra os dados do locale pt-BR globalmente pra o CurrencyPipe /
// DatePipe / NumberPipe funcionarem quando passamos ':pt-BR' explicitamente.
// Precisa ser antes do bootstrap.
registerLocaleData(localePtBr, 'pt-BR');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));